import { render, staticRenderFns } from "./related_work_items.vue.js?vue&type=template&id=1b5854d4&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./related_work_items.vue?vue&type=template&id=1b5854d4&vue3"
import script from "./related_work_items.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./related_work_items.vue?vue&type=script&lang=js&vue3"
export * from "./related_work_items.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./related_work_items.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports